<app-header [enableBack]="true"></app-header>

<div class="p-6">
  <app-table
    [config]="tableConfig"
    [data]="tableData"
    [(selectedElements)]="selectedElements">
  </app-table>
</div>
